import { makeAutoObservable } from "mobx";
import { ModalType, ModalPropsMap } from "@/types/modal";

export class ModalStore {
	type: ModalType | null = null;
	props: ModalPropsMap[ModalType] | null = null;

	constructor() {
		makeAutoObservable(this);
	}

	open<T extends ModalType>(type: T, props: ModalPropsMap[T]) {
		this.type = type;
		this.props = props;
	}

	close() {
		this.type = null;
		this.props = null;
	}
}
